(function () {
  'use strict';

  var ZOOM_LEVEL = 2;
  var DRAG_THRESHOLD = 10;
  var SWIPE_THRESHOLD = 50;

  var lightbox = null;
  var state = {
    items: [],
    index: 0,
    scale: 1,
    translateX: 0,
    translateY: 0,
    lastTrigger: null,
    galleryRoot: null,
    isDragging: false,
    dragStartX: 0,
    dragStartY: 0,
    dragOriginX: 0,
    dragOriginY: 0,
    pointerDownX: 0,
    pointerDownY: 0,
    pointerMoved: false,
    pinchStartDistance: 0,
    pinchStartScale: 1,
    suppressClick: false
  };

  var carouselPointer = {
    active: false,
    downX: 0,
    downY: 0,
    moved: false
  };

  var ICONS = {
    close:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.213 55.962" aria-hidden="true" focusable="false"><path d="M48.82,53.907,27.483,32.572,6.146,53.907a3.6,3.6,0,0,1-5.091-5.09L22.393,27.481,1.055,6.145a3.6,3.6,0,0,1,5.09-5.09L27.483,22.391,48.82,1.055a3.6,3.6,0,0,1,5.09,5.09L32.573,27.482,53.911,48.818a3.6,3.6,0,1,1-5.09,5.09Z" transform="translate(0.747 0.5)"/></svg>',
    arrow:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 263.7 473.1" aria-hidden="true" focusable="false"><path d="M244.5,473.1c-4.9,0-9.8-1.9-13.6-5.6L0,236.5L230.9,5.6c7.5-7.5,19.7-7.5,27.2,0c7.5,7.5,7.5,19.7,0,27.2L54.3,236.5 l203.7,203.7c7.5,7.5,7.5,19.7,0,27.2C254.3,471.2,249.4,473.1,244.5,473.1z"/></svg>'
  };

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getDistance(t1, t2) {
    var dx = t2.clientX - t1.clientX;
    var dy = t2.clientY - t1.clientY;
    return Math.hypot(dx, dy);
  }

  function ensureLightbox() {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'lop-pdp-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Visor de imagen del producto');
    lightbox.hidden = true;
    lightbox.innerHTML =
      '<p class="lop-pdp-lightbox__counter" aria-live="polite"></p>' +
      '<button type="button" class="lop-pdp-lightbox__close" aria-label="Cerrar">' +
      ICONS.close +
      '</button>' +
      '<button type="button" class="lop-pdp-lightbox__nav lop-pdp-lightbox__nav--prev" aria-label="Imagen anterior">' +
      ICONS.arrow +
      '</button>' +
      '<button type="button" class="lop-pdp-lightbox__nav lop-pdp-lightbox__nav--next" aria-label="Imagen siguiente">' +
      ICONS.arrow +
      '</button>' +
      '<div class="lop-pdp-lightbox__stage">' +
      '<div class="lop-pdp-lightbox__viewport">' +
      '<div class="lop-pdp-lightbox__image-wrap">' +
      '<img class="lop-pdp-lightbox__image" alt="" width="1600" height="1600" decoding="async">' +
      '</div>' +
      '</div>' +
      '</div>';

    document.body.appendChild(lightbox);

    lightbox.querySelector('.lop-pdp-lightbox__close').addEventListener('click', close);
    lightbox.querySelector('.lop-pdp-lightbox__nav--prev').addEventListener('click', function () {
      goTo(state.index - 1);
    });
    lightbox.querySelector('.lop-pdp-lightbox__nav--next').addEventListener('click', function () {
      goTo(state.index + 1);
    });

    var stage = lightbox.querySelector('.lop-pdp-lightbox__stage');
    stage.addEventListener('click', onStageClick);
    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerup', onPointerUp);
    stage.addEventListener('pointercancel', onPointerUp);
    stage.addEventListener('pointerleave', onPointerLeave);
    stage.addEventListener('touchstart', onTouchStart, { passive: false });
    stage.addEventListener('touchmove', onTouchMove, { passive: false });
    stage.addEventListener('touchend', onTouchEnd);

    document.addEventListener('keydown', onKeyDown);

    return lightbox;
  }

  function getElements() {
    return {
      counter: lightbox.querySelector('.lop-pdp-lightbox__counter'),
      closeBtn: lightbox.querySelector('.lop-pdp-lightbox__close'),
      prevBtn: lightbox.querySelector('.lop-pdp-lightbox__nav--prev'),
      nextBtn: lightbox.querySelector('.lop-pdp-lightbox__nav--next'),
      viewport: lightbox.querySelector('.lop-pdp-lightbox__viewport'),
      imageWrap: lightbox.querySelector('.lop-pdp-lightbox__image-wrap'),
      image: lightbox.querySelector('.lop-pdp-lightbox__image')
    };
  }

  function collectItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.lop-pdp-lightbox-trigger[data-lop-zoom-src]')).map(function (trigger) {
      return {
        src: trigger.getAttribute('data-lop-zoom-src'),
        alt: trigger.getAttribute('data-lop-zoom-alt') || '',
        trigger: trigger
      };
    });
  }

  function resetTransform() {
    state.scale = 1;
    state.translateX = 0;
    state.translateY = 0;
    applyTransform();
  }

  function getPanLimits() {
    var els = getElements();
    var viewport = els.viewport;
    var image = els.image;

    if (!viewport || !image || state.scale <= 1) {
      return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
    }

    var viewportRect = viewport.getBoundingClientRect();
    var baseWidth = image.offsetWidth;
    var baseHeight = image.offsetHeight;
    var scaledWidth = baseWidth * state.scale;
    var scaledHeight = baseHeight * state.scale;
    var overflowX = Math.max(0, (scaledWidth - viewportRect.width) / 2);
    var overflowY = Math.max(0, (scaledHeight - viewportRect.height) / 2);

    return {
      minX: -overflowX,
      maxX: overflowX,
      minY: -overflowY,
      maxY: overflowY
    };
  }

  function applyTransform() {
    var els = getElements();
    var limits = getPanLimits();

    state.translateX = clamp(state.translateX, limits.minX, limits.maxX);
    state.translateY = clamp(state.translateY, limits.minY, limits.maxY);

    els.imageWrap.style.transform =
      'translate3d(' + state.translateX + 'px, ' + state.translateY + 'px, 0) scale(' + state.scale + ')';

    els.viewport.classList.toggle('is-zoomed', state.scale > 1);
    els.viewport.classList.toggle('is-dragging', state.isDragging);
    els.viewport.style.cursor = state.scale > 1 ? (state.isDragging ? 'grabbing' : 'grab') : 'zoom-in';
  }

  function updateCounter() {
    var els = getElements();
    if (!els.counter || !state.items.length) return;
    els.counter.textContent = state.index + 1 + ' / ' + state.items.length;
  }

  function updateNavVisibility() {
    var els = getElements();
    var single = state.items.length <= 1;
    els.prevBtn.hidden = single;
    els.nextBtn.hidden = single;
  }

  function renderImage() {
    var item = state.items[state.index];
    if (!item) return;

    var els = getElements();
    resetTransform();
    els.image.src = item.src;
    els.image.alt = item.alt;
    lightbox.setAttribute('aria-label', item.alt || 'Visor de imagen del producto');
    updateCounter();
    updateNavVisibility();
  }

  function goTo(nextIndex) {
    if (!state.items.length) return;

    var total = state.items.length;
    var wrapped = ((nextIndex % total) + total) % total;
    if (wrapped === state.index) return;

    state.index = wrapped;
    renderImage();
  }

  function open(trigger) {
    var galleryRoot = trigger.closest('.lop-pdp-gallery-viewport');
    if (!galleryRoot) return;

    ensureLightbox();
    state.galleryRoot = galleryRoot;
    state.items = collectItems(galleryRoot);
    if (!state.items.length) return;

    state.lastTrigger = trigger;
    state.index = Math.max(
      0,
      state.items.findIndex(function (item) {
        return item.trigger === trigger;
      })
    );

    renderImage();
    lightbox.hidden = false;
    lightbox.classList.add('is-open');
    document.body.classList.add('lop-pdp-lightbox-open');
    getElements().closeBtn.focus();
  }

  function syncCarousel() {
    if (!state.galleryRoot) return;

    var item = state.items[state.index];
    if (!item || !item.trigger) return;

    var mainCarousel = state.galleryRoot.querySelector('xo-carousel:not(.product-info-media-carousel__thumbnail)');
    if (!mainCarousel) return;

    var slides = Array.prototype.slice.call(mainCarousel.querySelectorAll('xo-carousel-list > xo-carousel-slide'));
    var slide = item.trigger.closest('xo-carousel-slide');
    var slideIndex = slides.indexOf(slide);

    if (slideIndex === -1) return;

    var thumbCarousel = state.galleryRoot.querySelector('.product-info-media-carousel__thumbnail');
    if (thumbCarousel) {
      var thumbSlides = thumbCarousel.querySelectorAll('xo-carousel-slide');
      if (thumbSlides[slideIndex]) {
        thumbSlides[slideIndex].click();
        return;
      }
    }

    if (slide) {
      slide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
    }
  }

  function close() {
    if (!lightbox || lightbox.hidden) return;

    syncCarousel();
    resetTransform();

    lightbox.classList.remove('is-open');
    lightbox.hidden = true;
    document.body.classList.remove('lop-pdp-lightbox-open');

    if (state.lastTrigger && typeof state.lastTrigger.focus === 'function') {
      state.lastTrigger.focus();
    }
  }

  function toggleZoom(clientX, clientY) {
    if (state.scale > 1) {
      resetTransform();
      return;
    }

    var els = getElements();
    var viewportRect = els.viewport.getBoundingClientRect();
    var relX = clientX - viewportRect.left - viewportRect.width / 2;
    var relY = clientY - viewportRect.top - viewportRect.height / 2;

    state.scale = ZOOM_LEVEL;
    state.translateX = -relX * (ZOOM_LEVEL - 1);
    state.translateY = -relY * (ZOOM_LEVEL - 1);
    applyTransform();
  }

  function onStageClick(event) {
    if (state.suppressClick) {
      state.suppressClick = false;
      return;
    }

    if (event.target.closest('.lop-pdp-lightbox__nav') || event.target.closest('.lop-pdp-lightbox__close')) {
      return;
    }

    if (state.pointerMoved) {
      state.pointerMoved = false;
      return;
    }

    var els = getElements();
    var clickedViewport = els.viewport.contains(event.target);

    if (!clickedViewport) {
      close();
      return;
    }

    toggleZoom(event.clientX, event.clientY);
  }

  function onPointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    state.pointerDownX = event.clientX;
    state.pointerDownY = event.clientY;
    state.pointerMoved = false;
    state.suppressClick = false;

    if (event.pointerType === 'touch' && event.isPrimary === false) return;

    if (state.scale > 1) {
      state.isDragging = true;
      state.dragStartX = event.clientX;
      state.dragStartY = event.clientY;
      state.dragOriginX = state.translateX;
      state.dragOriginY = state.translateY;
      event.currentTarget.setPointerCapture(event.pointerId);
      applyTransform();
      return;
    }

    state.swipeStartX = event.clientX;
    state.swipeStartY = event.clientY;
  }

  function onTouchStart(event) {
    if (event.touches.length === 2 && state.scale > 1) {
      state.pinchStartDistance = getDistance(event.touches[0], event.touches[1]);
      state.pinchStartScale = state.scale;
      event.preventDefault();
    }
  }

  function onTouchMove(event) {
    if (event.touches.length === 2 && state.pinchStartDistance && state.scale > 1) {
      event.preventDefault();
      var distance = getDistance(event.touches[0], event.touches[1]);
      state.scale = clamp((distance / state.pinchStartDistance) * state.pinchStartScale, 1, 3);

      if (state.scale <= 1.01) {
        resetTransform();
        state.pinchStartDistance = 0;
        return;
      }

      applyTransform();
    }
  }

  function onTouchEnd(event) {
    if (!event.touches.length) {
      state.pinchStartDistance = 0;
    }
  }

  function onPointerMove(event) {
    var dx = event.clientX - state.pointerDownX;
    var dy = event.clientY - state.pointerDownY;

    if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) {
      state.pointerMoved = true;
    }

    if (state.isDragging && state.scale > 1) {
      state.translateX = state.dragOriginX + (event.clientX - state.dragStartX);
      state.translateY = state.dragOriginY + (event.clientY - state.dragStartY);
      applyTransform();
      return;
    }
  }

  function onPointerUp(event) {
    if (state.isDragging) {
      state.isDragging = false;
      applyTransform();
      if (state.pointerMoved) {
        state.suppressClick = true;
      }
      try {
        event.currentTarget.releasePointerCapture(event.pointerId);
      } catch (e) {
        /* noop */
      }
      return;
    }

    state.pinchStartDistance = 0;

    if (state.scale <= 1 && event.pointerType === 'touch' && typeof state.swipeStartX === 'number') {
      var dx = event.clientX - state.swipeStartX;
      var dy = event.clientY - state.swipeStartY;

      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) {
          goTo(state.index + 1);
        } else {
          goTo(state.index - 1);
        }
        state.suppressClick = true;
      }
    }

    state.swipeStartX = null;
    state.swipeStartY = null;
  }

  function onPointerLeave(event) {
    if (state.isDragging) {
      onPointerUp(event);
    }
  }

  function onKeyDown(event) {
    if (!lightbox || lightbox.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goTo(state.index - 1);
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(state.index + 1);
    }
  }

  function onDocumentClick(event) {
    var trigger = event.target.closest('.lop-pdp-lightbox-trigger');
    if (!trigger || !trigger.closest('.main-product')) return;

    if (carouselPointer.moved) {
      carouselPointer.moved = false;
      return;
    }

    event.preventDefault();
    open(trigger);
  }

  function onCarouselPointerDown(event) {
    var trigger = event.target.closest('.lop-pdp-lightbox-trigger');
    if (!trigger || !trigger.closest('.main-product')) return;

    carouselPointer.active = true;
    carouselPointer.downX = event.clientX;
    carouselPointer.downY = event.clientY;
    carouselPointer.moved = false;
  }

  function onCarouselPointerMove(event) {
    if (!carouselPointer.active) return;

    var dx = event.clientX - carouselPointer.downX;
    var dy = event.clientY - carouselPointer.downY;

    if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) {
      carouselPointer.moved = true;
    }
  }

  function onCarouselPointerUp() {
    carouselPointer.active = false;
  }

  function init() {
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('pointerdown', onCarouselPointerDown, true);
    document.addEventListener('pointermove', onCarouselPointerMove, true);
    document.addEventListener('pointerup', onCarouselPointerUp, true);
    document.addEventListener('pointercancel', onCarouselPointerUp, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
